import React from 'react';
import { PropTypes } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useDialogState } from '~/modules/common/hooks';
import CertificateReadOnly from './CertificateReadOnly';
import CertificateDialog from './EditCertificateDialog';

const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: theme.spacing(-2)
  }
}));

export const EditCertificate = ({
  userUri,
  editable,
  certificate,
  canEditSkills,
  onAcceptCertificateNudges,
  onRejectCertificateNudges
}) => {
  const classes = useStyles();
  const {
    open: dialogOpen,
    openDialog: onEdit,
    closeDialog: onCancel
  } = useDialogState(false);

  return (
    <div className={classes.container}>
      <CertificateReadOnly
        certificate={certificate}
        editable={editable}
        canEditSkills={canEditSkills}
        onEdit={onEdit}
        onAcceptCertificateNudges={onAcceptCertificateNudges}
        onRejectCertificateNudges={onRejectCertificateNudges}
      />
      <CertificateDialog
        certificate={certificate}
        open={dialogOpen}
        onCancel={onCancel}
        userUri={userUri}
      />
    </div>
  );
};

EditCertificate.propTypes = {
  editable: PropTypes.bool.isRequired,
  certificate: PropTypes.object.isRequired,
  userUri: PropTypes.string.isRequired,
  canEditSkills: PropTypes.bool.isRequired,
  onAcceptCertificateNudges: PropTypes.func.isRequired,
  onRejectCertificateNudges: PropTypes.func.isRequired
};

export default EditCertificate;
